import React from "react";
import styles from "./style.module.css";
import { images } from "../../../../assets/images";

const ImageCraousel = () => {
  const { CommunityMember, Member2 } = images;

  const data = [
    CommunityMember,
    Member2,
    CommunityMember,
    Member2,
    CommunityMember,
    Member2,
    CommunityMember,
    Member2,
    CommunityMember,
    Member2,
    CommunityMember,
    Member2,
    CommunityMember,
    Member2,
    CommunityMember,
    Member2,
    CommunityMember,
    Member2,
    CommunityMember,
    Member2,
    CommunityMember,
    Member2,
    CommunityMember,
    Member2,
    CommunityMember,
  ];

  const chunkArray = (arr, chunkSize) => {
    let result = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      result.push(arr.slice(i, i + chunkSize));
    }
    return result;
  };

  const columns = chunkArray(data, 2);

  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        {columns.map((column, index) => (
          <div key={index} className={styles.imgContainer}>
            {column.map((image, idx) => (
              <img key={idx} src={image} alt="Member" />
            ))}
          </div>
        ))}
      </div>
      <div className={styles.innerContainer}>
        {columns.map((column, index) => (
          <div key={index} className={styles.imgContainer}>
            {column.map((image, idx) => (
              <img key={idx} src={image} alt="Member" />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageCraousel;
